<script setup lang="ts">
import PopOver from '@/uiKit/PopOver.vue'
import type { OffsetOptions } from '@floating-ui/vue'
import { POPOVER_Z_INDEX } from './useTableZIndices'

interface Props {
  offset?: number | OffsetOptions
}

const props = defineProps<Props>()

const labelId = 'project-table-cell-tooltip-label'
</script>

<template>
  <PopOver
    :open="true"
    :auto-placement-options="{ allowedPlacements: ['top-start'] }"
    :aria-labelledby="labelId"
    teleport-to="#grid-container"
    :floating-z-index="POPOVER_Z_INDEX"
    :offset="props.offset"
  >
    <template #content>
      <slot />
    </template>
  </PopOver>
</template>
